import { useQueryClient } from '@tanstack/react-query';

import { API_CACHE_KEYS } from '@/features/api/constants/cache';
import { useGrapevineOrganizationApi } from '@/features/api/hooks/grapevine-organization/useGrapevineOrganizationApi';
import { useApiMutation } from '@/features/api/hooks/useApiMutation';

type DeleteOrganizationVariables = {
  organizationId: string;
};

export const useDeleteOrganization = () => {
  const queryClient = useQueryClient();
  const api = useGrapevineOrganizationApi();

  return useApiMutation<void, unknown, DeleteOrganizationVariables>({
    mutationFn: ({ organizationId }) =>
      api.deleteOrganization({ organizationId }),
    onSuccess: (_data, variables) => {
      queryClient.invalidateQueries({
        queryKey: [API_CACHE_KEYS.OWN_ORGANIZATIONS]
      });
      queryClient.invalidateQueries({
        queryKey: [API_CACHE_KEYS.POST_CREATION_OPTIONS]
      });
      queryClient.invalidateQueries({
        queryKey: [API_CACHE_KEYS.ORGANIZATIONS]
      });
      queryClient.invalidateQueries({
        queryKey: [API_CACHE_KEYS.ORGANIZATION, variables.organizationId]
      });
      queryClient.invalidateQueries({
        queryKey: [API_CACHE_KEYS.ORGANIZATIONS_IN_GEO_AREA]
      });
      queryClient.invalidateQueries({
        queryKey: [API_CACHE_KEYS.ORGANIZATIONS_IN_OWN_GEO_AREA_SELECTION]
      });
    }
  });
};
